import {
  BadgePercent,
  BanknoteArrowDown,
  BanknoteArrowUp,
  BookMarked,
  BookText,
  Building2,
  CalendarClock,
  CalendarCog,
  CalendarDays,
  ChartColumn,
  ChartNoAxesCombined,
  ClipboardCheck,
  Coins,
  Compass,
  CreditCard,
  Crown,
  FormInput,
  Gift,
  HandCoins,
  HistoryIcon,
  IdCard,
  Landmark,
  ListChecks,
  Mail,
  MapPin,
  PersonStanding,
  Receipt,
  ReceiptText,
  RefreshCw,
  Repeat,
  Rss,
  Scale,
  ScanEye,
  ScrollText,
  SearchCode,
  Settings,
  Settings2,
  ShieldAlert,
  ShoppingBasket,
  Smartphone,
  Speech,
  Tags,
  TrendingUpDown,
  Truck,
  Undo2,
  Users,
  UsersRound,
  VectorSquare,
  Wallet,
  WalletCards,
  Warehouse,
} from 'lucide-react';

export const SIDEBAR_MENU_ICONS = {
  catalog: BookMarked,
  clients: Users,
  new_clients: PersonStanding,
  calendar: ClipboardCheck,
  booking_calendar: CalendarClock,
  reservations: ListChecks,
  group_schedules: Repeat,
  company_events: CalendarCog,
  certificates: Gift,
  promotions: CalendarDays,
  services: ShoppingBasket,
  service_categories: VectorSquare,
  cards: WalletCards,
  orders_info: HandCoins,
  user_logs: HistoryIcon,
  access_passes: IdCard,
  trainers: Speech,
  service_usage_history: SearchCode,
  online_services: Rss,
  locations: MapPin,
  income_payment_settings: BanknoteArrowDown,
  analytics: ChartColumn,
  booking_analytics: ChartNoAxesCombined,
  scanning_devices: ScanEye,
  terminals: Smartphone,
  acquiring: CreditCard,
  settings: Settings2,
  legal_entities: Landmark,
  business_directions: Compass,
  cash_registers: Wallet,
  edit_company: Settings,
  custom_fields: FormInput,
  companies: Building2,
  staff: UsersRound,
  salary: Coins,
  system_owners: Crown,
  ledger: BookText,
  email_templates: Mail,
  transaction_categories: Tags,
  discount_reasons: BadgePercent,
  refund_reasons: Undo2,
  cash: Wallet,
  cash_flow: TrendingUpDown,
  profit_and_loss: Scale,
  warehouse: Warehouse,
  suppliers: Truck,
  waybills: ReceiptText,
  operations: ScrollText,
  recognition_runs: RefreshCw,
  fiscalization: Receipt,
  specialist_payouts: BanknoteArrowUp,
  product_reports: ChartColumn,

  Default: ShieldAlert,
};
